import React, { useMemo, useState } from 'react';
import { MapContainer, Marker, TileLayer, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const LIMA_CENTER = [-12.0464, -77.0428];

function markerIcon() {
  return L.divIcon({
    className: '',
    html: `
      <div style="
        width:30px;height:30px;border-radius:999px;background:#B1336E;color:white;
        display:flex;align-items:center;justify-content:center;border:2px solid white;
        box-shadow:0 6px 14px rgba(15,23,42,.25);font-weight:800;
      ">F</div>
    `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });
}

function MapClickHandler({ onPick }) {
  useMapEvents({
    click(event) {
      onPick(event.latlng.lat, event.latlng.lng);
    },
  });
  return null;
}

function DriverFinalLocationPicker({ driver, onClose, onSave }) {
  const initialPosition = useMemo(() => {
    const lat = Number(driver?.final_latitude || driver?.latitude);
    const lng = Number(driver?.final_longitude || driver?.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) return [lat, lng];
    return LIMA_CENTER;
  }, [driver]);
  const [position, setPosition] = useState(initialPosition);
  const icon = useMemo(() => markerIcon(), []);

  if (!driver) return null;

  function handlePick(lat, lng) {
    setPosition([lat, lng]);
  }

  return (
    <div className="fixed inset-0 z-[2400] flex items-center justify-center bg-slate-900/50 p-4">
      <div className="flex max-h-[90vh] w-full max-w-3xl flex-col rounded-lg bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
          <div>
            <h3 className="font-bold text-slate-900">Punto final de {driver.name}</h3>
            <p className="text-xs text-slate-500">Haz click en el mapa o arrastra el marcador.</p>
          </div>
          <button onClick={onClose} className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-bold text-slate-600">
            Cerrar
          </button>
        </div>

        <div className="h-[440px] min-h-0">
          <MapContainer center={position} zoom={12} scrollWheelZoom className="h-full w-full">
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MapClickHandler onPick={handlePick} />
            <Marker
              position={position}
              icon={icon}
              draggable
              eventHandlers={{
                dragend(event) {
                  const next = event.target.getLatLng();
                  handlePick(next.lat, next.lng);
                },
              }}
            />
          </MapContainer>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3">
          <div className="text-xs font-semibold text-slate-600">
            Lat {position[0].toFixed(6)} | Lng {position[1].toFixed(6)}
          </div>
          <button
            onClick={() => onSave(position[0], position[1])}
            className="rounded-lg bg-brand-primary px-4 py-2 text-sm font-bold text-white"
          >
            Guardar punto final
          </button>
        </div>
      </div>
    </div>
  );
}

export default DriverFinalLocationPicker;
